// Auto-generated by scripts/generate-registry.mjs from packages/modules/notched_box_lamp/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const notched_box_lamp: ModuleSchema = {
  "id": "notched_box_lamp",
  "uniqueId": "B3D_NBX01",
  "createdAt": "2026-10-22T00:00:00Z",
  "updatedAt": "2026-10-22T06:11:39.376Z",
  "label": "Hanging Box Holder",
  "description": "A hollow rounded box holder with a separate U-hook. Its reverse latch drops through the long rear slot and holds under the slot edge; partition thickness is adjustable from 20 to 60 mm.",
  "category": "lamp",
  "tags": [
    "lamp",
    "box shade",
    "wall hook",
    "partition hook"
  ],
  "sliders": [
    {
      "key": "width",
      "label": "Shade Width",
      "min": 40,
      "max": 100,
      "step": 1,
      "default": 58,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "depth",
      "label": "Shade Depth",
      "min": 36,
      "max": 90,
      "step": 1,
      "default": 48,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "height",
      "label": "Shade Height",
      "min": 60,
      "max": 180,
      "step": 2,
      "default": 150,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "wallThickness",
      "label": "Partition Thickness",
      "min": 20,
      "max": 60,
      "step": 1,
      "default": 42,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "box_body",
      "label": "Hollow Box Body with Long Hook Slot",
      "default": "#8b8b87",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "partition_hook",
      "label": "U Hook with Reverse Latch",
      "default": "#8b8b87",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "box_obj",
      "label": "Notched Box Body",
      "name": "Notched Box Body",
      "color": "#8b8b87",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "box_body",
          "label": "Hollow Box Body with Long Hook Slot",
          "name": "Hollow Box Body with Long Hook Slot",
          "groupId": 0,
          "colorKey": "box_body",
          "defaultColor": "#8b8b87",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    },
    {
      "id": "hook_obj",
      "label": "Separate U Hook",
      "name": "Separate U Hook",
      "color": "#8b8b87",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "partition_hook",
          "label": "U Hook with Reverse Latch",
          "name": "U Hook with Reverse Latch",
          "groupId": 1,
          "colorKey": "partition_hook",
          "defaultColor": "#8b8b87",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Box and Hook"
    },
    {
      "id": "box_body",
      "label": "Download STL - Box Body"
    },
    {
      "id": "partition_hook",
      "label": "Download STL - Separate Hook"
    }
  ]
};
